module.exports = __webpack_public_path__ + "img/jhsys1.acf94df7.png";